const form = {
  url: "https://docs.google.com/forms/d/e/1FAIpQLScDDFqg9ycLb0465xwh3rwV7Ceo34rdfkWgxveGlCAVM8FLZg/formResponse",
  method: "post",
};

export default form;
